import { hasMemberOrganisationAccess, isOrganisationGroupUser } from "../OrganisationGroups/utils/roleAccess";

export const hasAuthenticatedUserData = (userData) =>
  Boolean(userData && typeof userData === "object" && Object.keys(userData).length);

export const getAuthToken = (userData) =>
  userData?.token || localStorage.getItem("token") || null;

export const getAuthenticatedHomeRoute = (userData) => {


  if (isOrganisationGroupUser(userData) && !hasMemberOrganisationAccess(userData)) {
    return "/organisations/dashboard";
  }
  return "/dashboard";
};

export const isAllowedAuthenticatedRoute = (pathname, userData) => {
  if (!pathname) return false;
  if (!hasAuthenticatedUserData(userData)) return false;

  const isOrganisationRoute = pathname.startsWith("/organisations");
  const isVideoShortsRoute = pathname.startsWith("/video-shorts");
  const isSettingsRoute = pathname.startsWith("/settings");
  const isHelpRoute = pathname.startsWith("/help-support");
  
  if (isOrganisationRoute) {
    return isOrganisationGroupUser(userData);
  } else if (isVideoShortsRoute || isSettingsRoute || isHelpRoute) {
    return hasMemberOrganisationAccess(userData) || isOrganisationGroupUser(userData);
  } else {
    return hasMemberOrganisationAccess(userData);
  }
};
